export const CREATE_FLOW_URL = {
  BASE: 'new',
  AGREEMENT: 'agreement',
  ACCOUNT: 'account',
  GENERAL: 'general',
  ACTIVITY: 'activity',
  LEGAL: 'legal',
};

export const CREATE_LOCAL_STORAGE_KEY = 'ONGHUB_CREATE_ORGANIZATION_DATA';
export const ORGANIZATION_AGREEMENT_KEY = 'ONGHUB_CREATE_ORGANIZATION_AGREEMENT';
export const CREATE_LOCAL_STORAGE_ACTIVE_STEP_KEY = 'ONGHUB_CREATE_ORGANIZATION_ACTIVE_STEP_INDEX';

export const CREATE_FILE_LOGO = 'logo';
export const CREATE_FILE_STATUTE = 'organizationStatute';
